import React, { useEffect, useState } from 'react'
import { Alert, Stack, Typography } from '@mui/material'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import OperationComparisonView from './OperationComparisonView'
import { compareOperationVersions, readOperationLibraryError } from './operationLibraryApi'

/**
 * OperationCompareDialog (C10, §8.7) — comparar DOS versiones de una operación desde la biblioteca
 * (N7, S91), con el título "Compare versions" (K44) y los mismos bloques y claves que el diálogo de
 * impacto: una comparación se lee igual venga de donde venga.
 */
const OperationCompareDialog = ({ open = false, fromNodeId = '', toNodeId = '', onClose = () => {} }) => {
  const { t_ } = useSmartTranslation()
  const [comparison, setComparison] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let current = true
    if (!open || !fromNodeId || !toNodeId) {
      setComparison(null)
      return () => { current = false }
    }
    setError('')
    compareOperationVersions({ fromNodeId, toNodeId })
      .then((result) => { if (current) setComparison(result || null) })
      .catch((thrown) => { if (current) setError(readOperationLibraryError(thrown).error) })
    return () => { current = false }
  }, [open, fromNodeId, toNodeId])

  return (
    <SmartDialog
      setOpen={open}
      title={{ render: <Typography variant='h6'>{t_('Compare versions')}</Typography> }}
      accept={false}
      cancel={false}
      close
      closeCallback={onClose}
      renderComponent={
        <Stack spacing={2} sx={{ mt: 1, minWidth: 360 }} data-testid='operation-compare-dialog'>
          {error ? <Alert severity='error' data-testid='operation-compare-error'>{t_(error)}</Alert> : null}
          <OperationComparisonView comparison={comparison} />
        </Stack>
      }
    />
  )
}

export default OperationCompareDialog
